<template>
    <div id="subsidiary-component">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <button type="button" class="formSubmit accordion" v-on:click="accordionPanel('formSubsidiary')">Agregar Sucursal</button>
                </div>
            </div>
            <form id="formSubsidiary" class="formSubsidiary">
                <div class="row">
                    <div class="col-12 col-sm-2">
                        <select id="estado" data-select="on" data-name-input="Estado" class="required" name="state_id" v-model="subsidiary.state_id" v-on:change="selectCities($event)">
                            <option :value="0">Selecciona un estado</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">{{ state.estado }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-2">
                        <select name="cities_id" data-name-input="Ciudad" data-select="on" class="required" id="ciudad" v-model="subsidiary.cities_id">
                            <option :value="0">Selecciona una ciudad</option>
                            <option v-for="city in cities" :value="city.id">{{ city.ciudad }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-4">
                        <input type="text" class="al-inputs" placeholder="Dirección" v-model="subsidiary.address">
                    </div>
                    <div class="col-12 col-sm-2">
                        <input type="tel" class="al-inputs" placeholder="Teléfono" v-model="subsidiary.phone">
                    </div>
                    <div class="col-12 col-sm-2">
                        <input type="tel" class="al-inputs" placeholder="Whats" v-model="subsidiary.whats">
                    </div>
                    <div class="col-12 col-sm-2">
                        <input type="email" class="al-inputs" placeholder="E-mail" v-model="subsidiary.email">
                    </div>
                    <div class="col-12 col-sm-12 mt-3">
                        <textarea v-model="subsidiary.horarios" style="height:50px; width: 100%;" placeholder="Horarios"></textarea>
                    </div>
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{ tituloBtn }}</button>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-12 col-sm-12">
                    <h2 class="cabeza">Sucursales</h2>
                    <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="subsidiaries">
                        <template #empty="scope">
                            <h4 class="emptyRow">
                                No hay datos para mostrar.
                            </h4>
                        </template>
                        <template #cell(estado)="{item}">
                            {{ item.reledo.estado }}
                        </template>
                        <template #cell(ciudad)="{item}">
                            {{ item.relcity.ciudad }}
                        </template>
                        <template #cell(direccion)="{item}">
                            {{ item.address }}
                        </template>
                        <template #cell(telefono)="{item}">
                            {{ item.phone }}
                        </template>
                        <template #cell(email)="{item}">
                            {{ item.email }}
                        </template>
                        <template #cell(acciones)="{item}">
                            <div class="dropdown">
                                <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-cogs"></i>
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="modificar=true; updateReg(item)">Editar</a>
                                    <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                                </div>
                            </div>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {statescitiesService} from "../../Services/Statescities.service";
import {estadoService} from "../../Services/States.service";
import {subsidiaryService} from "../../Services/Subsidiary.service";

export default {
    name: 'subsidiary',
    mixins: [myMixins],
    props: {
        supplier_id: {
            type: Number,
            required: true
        },

        role_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            modificar: false,
            isBusy: false,
            subsidiaries: [],
            states: [],
            cities: [],
            fields: [
                {key: 'estado'},
                {key: 'ciudad'},
                {key: 'direccion'},
                {key: 'telefono'},
                {key: 'email'},
                {key: 'acciones'},
            ],
            subsidiary: {
                cities_id: 0,
                role_id: this.role_id,
                supplier_id: this.supplier_id,
                state_id: 0,
                address: '',
                phone: '',
                email: '',
                horarios: '',
                whats: '',
            },
            selectSubsidiary: {
                where: [{
                    field: 'supplier_id',
                    operator: '=',
                    value: this.supplier_id,
                }, {
                    field: 'role_id',
                    operator: '=',
                    value: this.role_id,
                }],
            },
            tituloBtn: 'Guardar Sucursal',
        }
    },
    methods: {
        updateReg(data = {}) {
            if (this.modificar) {
                this.selectCities(data.state_id);
                this.tituloBtn = 'Actualizar Sucursal';
                this.subsidiary = data;
                this.accordionPanel('formSubsidiary');
            }
        },
        async onClickDelete(id) {
            let resp = await subsidiaryService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async selectCities($e) {
            let state_id = this.stateId($e);
            this.cities = await statescitiesService.getCitiesByState(state_id);
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formSubsidiary');

            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await subsidiaryService.updateOne(this.subsidiary.id, this.subsidiary);
                } else {
                    resp = await subsidiaryService.saveOne(this.subsidiary);
                }
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },
        async index() {
            this.isBusy = true;
            this.states = await estadoService.getMany({limit: 0});
            this.subsidiaries = await subsidiaryService.getMany(this.selectSubsidiary);
            this.isBusy = false;
        },
        setEmpty() {
            this.subsidiary = {
                cities_id: 0,
                role_id: this.role_id,
                supplier_id: this.supplier_id,
                state_id: 0,
                address: '',
                phone: '',
                email: '',
            };
        }
    },
    mounted() {
        this.index();
    }
}
</script>
